export default "__VITE_ASSET__shP1LAP6__"